import axios, { AxiosError, AxiosResponse } from 'axios';
import { GestorCapas, subirGestorCapas } from '../../../models/GestorCapas';
import { interceptor } from '../../../utils/axios.interceptor';
import {
  gestorCapasCatastroMineroListEndPoint,
  gestorCapasPostEndPoint,
  lastUpdateLayersCMEndPoint,
} from '../../../utils/endPoints';

export const gestorCapasInstance = axios.create();
interceptor(gestorCapasInstance);

export class GestorCapasService {
  /**
   * Used to get the list gestor de capas catastro minero
   * @returns Gestor capas catastro minero List
   */
  async getListCapasCatastroMinero(): Promise<{
    status: number;
    data: GestorCapas[];
  }> {
    try {
      const response = await gestorCapasInstance.get(
        gestorCapasCatastroMineroListEndPoint,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: err.response?.status as number,
        data: [],
      };
    }
  }

  /**
   * Used to upload file .zip catastro minero or auxiliares
   * @returns file upload
   */
  async uploadCapasCatastroMineroOrAuxiliares(
    capas: subirGestorCapas,
  ): Promise<{
    status: boolean;
    data: AxiosResponse | unknown;
  }> {
    try {
      const response = await gestorCapasInstance.post(
        gestorCapasPostEndPoint,
        capas,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      return {
        status: true,
        data: response.data.results,
      };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: false,
        data: err.response?.data,
      };
    }
  }

  /**
   * Used to get the last date and filename of a layer of CM that was updated
   * @returns Last Update Info of layers in CM
   */
  async getLastUpdateLayersCM(): Promise<{
    status: number;
    data: {
      lastUpdateDate?: string | null;
      lastUpdateLayerFilename?: string | null;
    };
  }> {
    try {
      const response = await gestorCapasInstance.get(
        lastUpdateLayersCMEndPoint,
      );
      return { status: response.status, data: response.data };
    } catch (error) {
      const err = error as AxiosError;
      return {
        status: err.response?.status as number,
        data: {},
      };
    }
  }
}
